"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const firestore_1 = require("@react-query-firebase/firestore");
const firestore_2 = require("firebase/firestore");
const keyFactory_1 = require("../../Firestore-Query/keyFactory");
/**
 *
 * @param firestore
 * @param country
 * @param options
 * @param useQueryOptions
 */
function usePriceMarketplace(firestore, country, options, useQueryOptions) {
    const path = {
        "AR": "parametros/userapp/prices/especialista",
        [country]: `parametros/${country}/prices/especialista`,
    };
    const appointmentRef = (0, firestore_2.doc)(firestore, path[country]);
    return (0, firestore_1.useFirestoreDocumentData)(keyFactory_1.FirestoreKeys.Especialista({
        name: "Price",
        path: path[country]
    }, [country]), appointmentRef, options, useQueryOptions);
}
exports.default = usePriceMarketplace;
